import React from "react";
import { useSelector } from "react-redux";
import UserProfile from "../../../lms-shared/UI/UserProfile";
import defaultAvatar from '../../../../assests/header/icon-user.png'
import classes from './Post.module.css'
import IdeRunner from "../../../lms-shared/IdeRunnerWarrper/IdeRunner";
import { ObjectTypeEnum } from "../../../../models/ObjectTypeEnum";
import { onKeyDown } from "../../../../service";
import moment from "moment";
import BtnSelect from "../../../UI/Buttons/BtnSelect";
import { FeedbackTypeTextEnum } from "../../../../models/FeedbackTypeEnum";

const Post = ({ p, remove, approve, setCurrentPostPlay, play, currentPostPlay }) => {

    const texts = useSelector((state) => state.translate.texts);

    const playPost = (postData) => {
        let ide = postData.contentData;
        if (ide) {
            let project = {
                // assessmentName: p.name,
                ideId: ide.Ide.Id,
                ideUrl: ide.Ide.Url,
                ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                ideLang: ide.Ide.Lang ? ide.Ide.Lang : "he",
                fileUrl: postData.url,
                share: true
            }
            setCurrentPostPlay({ id: postData.id, projectData: project });
        }
    }
    const getDateAgo = (p) => {
        let now = moment()
        var b = moment(p.updatedDate);
        let date = now.diff(b, 'days')   // =1
        if (date == 1)
            return texts.yesterday
        else if (date == 0)
            return texts.today
        return `${texts.before} ${date} ${texts.days}`
    }
    const feedbackUser = p.feedbacks[FeedbackTypeTextEnum.offensive].user;
    return (
        <div className={classes.PostWarrper}>
            <div className={classes.UserWithDots}>
                {p?.user &&
                    <div className={classes.UserWarrper}>
                        <UserProfile width="47px" image={p.user.profileImage ? `${p.user.profileImage}` : defaultAvatar} />
                        <div className={classes.User}>
                            <div className={classes.UsesDetails}>
                                <div> {p.user.firstName} {p.user.lastName?.[0]}. </div>
                            </div>
                            <div className={classes.Date}> {getDateAgo(p)} <span></span></div>
                        </div>
                    </div>}
            </div>

            <div className={classes.PostName}>{p?.name}</div>

            <div className={classes.CurrentPostwarrper}>
                {play ?
                    <div className={`${p?.contentData && p?.contentData.Ide.Id === 1 ? classes.CurrentMKPost : classes.CurrentPost}`}>
                        <IdeRunner projectData={currentPostPlay.projectData}></IdeRunner>
                    </div> :
                    <div className={classes.StartImage} style={{ backgroundImage: `url(${p?.thumbnail})` }}>
                        <div className={classes.Play} onClick={() => playPost(p)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => playPost(p))}></div>
                    </div>}
            </div>

            <div className={classes.Report}>
                {feedbackUser && <div className={classes.ReportUser}>
                    <div className={classes.ReportText}>{feedbackUser.isStudent ?texts.reportedAsOffensive:texts.requiredRemove}</div>
                    <div>{texts.per} {feedbackUser.isStudent ? texts.theStudent : texts.theTeacher} {feedbackUser.firstName} {feedbackUser.lastName}</div>
                </div>}
                <div className={classes.Btns}>
                    <BtnSelect dropStyle={{width:"114px",height:"30px",fontWeight:"bold"}} onClick={() => approve(p.id)}>{texts.approve}</BtnSelect>
                    <BtnSelect dropStyle={{width:"114px",height:"30px",fontWeight:"bold"}} checked={true} onClick={() => remove(p.id)}>{texts.remove}</BtnSelect>
                </div>
            </div>
            {/* <div>feedback {p.feedbacks[FeedbackTypeTextEnum.offensive].count}</div> */}

        </div>
    )
}

export default Post;